import type { AppApi, PresetDefinition } from '@wix/wix-data-client-common'
import { generateUniquePageRole, PAGE_TYPES } from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { Schema } from '@wix/wix-data-schema-types'
import { getRouterPrefixAndPattern } from './getRouterPrefixAndPattern'
import { buildPageName } from '../utils/buildPageName'
import { addRouter } from './addRouter'

export const addDynamicItemPage = async ({
  editorSdkProxy,
  schema,
  preset,
  appApi,
}: {
  editorSdkProxy: EditorSDK
  schema: Schema
  preset: PresetDefinition
  appApi: AppApi
}) => {
  const { newRouterPrefix, pattern } = await getRouterPrefixAndPattern({
    editorSdkProxy,
    appApi,
    newCollectionSchema: schema,
  })

  const pageDefinition = preset.pages.find(page => page.type === 'itemPage')

  if (!pageDefinition) {
    throw new Error('Preset page definition not found')
  }

  const pageTitle = buildPageName({
    collectionName: schema.displayName,
    pageType: PAGE_TYPES.ITEM,
  })

  const pageRef = await editorSdkProxy.document.pages.add({
    title: pageTitle,
    definition: pageDefinition.definition,
    shouldAddMenuItem: true,
    shouldNavigateToPage: false,
  })

  const pageRole = await generateUniquePageRole({ editorSdkProxy })

  await addRouter({
    editorSdkProxy,
    newCollectionSchema: schema,
    presetRouter: preset.routers[0],
    presetPageId: pageDefinition.definition.id,
    pageRef,
    pattern,
    newRouterPrefix,
    pageRole,
  })

  return { pageRef, pageUrl: `${newRouterPrefix}${pattern}` }
}
